import React, { createContext, useContext, useState } from 'react'

const LoginPopupContext = createContext(null)

export const LoginPopupProvider = ({ children }) => {
  const [loginPopup, setLoginPopup] = useState(false)
  const [loginData, setLoginData] = useState({ email: '', password: '', rememberMe: false })
  const [loginView, setLoginView] = useState('login')
  const [isLoading, setIsLoading] = useState(false)

  const openLogin = () => setLoginPopup(true)

  const closeLoginPopup = () => {
    setLoginPopup(false)
    setLoginView('login')
    setLoginData({ email: '', password: '', rememberMe: false })
  }

  const handleLogin = (e) => {
    e.preventDefault()
    setIsLoading(true)
    // TODO: Implement login logic
    console.log('Login attempt:', loginData)
    setTimeout(() => {
      setIsLoading(false)
      setLoginPopup(false)
      setLoginView('login')
    }, 1500)
  }

  const handleForgotPassword = (e) => {
    e.preventDefault()
    setIsLoading(true)
    // TODO: Implement forgot password logic
    console.log('Forgot password for:', loginData.email)
    setTimeout(() => {
      setIsLoading(false)
      setLoginView('login')
    }, 1500)
  }

  const value = {
    openLogin,
    closeLoginPopup,
    loginPopup,
    loginData,
    setLoginData,
    loginView,
    setLoginView,
    isLoading,
    handleLogin,
    handleForgotPassword
  }

  return (
    <LoginPopupContext.Provider value={value}>
      {children}
    </LoginPopupContext.Provider>
  )
}

export const useLoginPopup = () => {
  const context = useContext(LoginPopupContext)
  if (!context) {
    throw new Error('useLoginPopup must be used within a LoginPopupProvider')
  }
  return context
}
